module.exports = __webpack_public_path__ + "static/media/SupportEmail.ce07d5ba.svg";